import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
let screenIdentifier = 'deiveryPickupScreen';
import * as UserActions from '../../actions/user_actions';
import { bindActionCreators } from 'redux';
import Modal from 'react-modal';
import * as SettingScreen from '../../actions/settingScreen_actions';
import { ModalDialogCommon } from '../modal_dialog_common';
let LogOut = React.createClass({
    getInitialState() {
        return {
            bool: false,
            logOut: true,
            session_expired:false
        }
    },
    componentWillReceiveProps(nextProps) {

      if(nextProps.UserDetails.sessionExpired && nextProps.UserDetails.sessionExpired.status === 203){
            this.setState({session_expired:true,logOut:false})
      }
        if (nextProps.SessionLogoutResponse) {
            if (nextProps.SessionLogoutResponse.status == 200) {
                this.props.Dispatch(UserActions.user_log_out());
                localStorage.clear();
                this.props.router.push('/');
            } else {
                // need to show error msg from server response
            }
        }

    },
    componentWillMount() {

    },
    ConfirmPrompt() {
        this.props.Dispatch(UserActions.logout(
            {
                "appType": "WEB",
                "id": this.props.LogingDetails.data.id
            }
        ));
    },
    confirm() {

    },
    removeCancelPrompt() {
        this.setState({
            logOut: false
        })
        this.props.router.goBack();
    },

    navigationHandler() {
    },
    closebox(){
      this.props.Dispatch(UserActions.user_log_out());
    //  this.ConfirmPrompt();
      localStorage.clear();
      this.props.router.push('/?timeout=1');
    },
    render() {
        return (
            <div>
                <Modal ref='deleteAddressModal' isOpen={this.state.logOut} className='delete-prompt modalPopup logout' contentLabel='modalPopup'>
                    <div className="popup-content text-center">
                        <p className='main_header'>
                            Are you sure you want to logout?
                    </p>
                        <div>
                            <input type='button' value='YES' className='button button-primary btn-submit gray-button' ref='deleteBtn' onClick={this.ConfirmPrompt} />
                            <input type='button' value='CANCEL' className='button button-primary btn-submit white-button' ref='deleteCancelBtn' onClick={this.removeCancelPrompt} />
                        </div>
                    </div>
                </Modal>
                  <div> {this.state.session_expired && <ModalDialogCommon message={"Your session has expired. Please log in again"} action={this.closebox} />}</div>
            </div>

        );
    }
});

let mapStateToProps = (state) => {
    return {
        UserDetails: state.User,
        LogingDetails: state.User.loginData,
        SessionLogoutResponse: state.User.sessionLogoutResponse,
    };
};

let mapDispatchToProps = (dispatch) => ({
    UserActions: bindActionCreators(UserActions, dispatch),
    Dispatch: dispatch
});
export default connect(mapStateToProps,
    mapDispatchToProps)(withRouter(LogOut));



/** WEBPACK FOOTER **
 ** ./src/components/logOutscreen/logout.js
 **/